<template>
    <div class="se-main">
        <transition
            name="el-fade-in"
            mode="out-in"
        >
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
        </transition>
        <transition
            name="el-fade-in"
            mode="out-in"
        >
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </transition>
    </div>
</template>
<script>
// 主体
export default {
    name: 'se-main',
    data() {
        return {

        };
    }
};
</script>
<style lang="scss" scoped>
</style>
